import _ from 'lodash';

export const isSVGLink = (imgUrl: string): boolean => /\.svg$/.test(imgUrl);

export const hasSameElements = <T,>(arr1: T[], arr2: T[]) =>
  _.isEmpty(_.xor(arr1, arr2));
